export interface Level {
  level: number;
  title: string;
  xpRequired: number;
}

const LEVELS: Level[] = [
  { level: 1, title: "Tee Ball Rookie", xpRequired: 0 },
  { level: 2, title: "Little Leaguer", xpRequired: 100 },
  { level: 3, title: "Travel Ball Player", xpRequired: 300 },
  { level: 4, title: "Varsity Starter", xpRequired: 600 },
  { level: 5, title: "All-Conference", xpRequired: 1000 },
  { level: 6, title: "All-State", xpRequired: 1500 },
  { level: 7, title: "College Prospect", xpRequired: 2500 },
  { level: 8, title: "College Starter", xpRequired: 4000 },
  { level: 9, title: "All-American", xpRequired: 6000 },
  { level: 10, title: "Draft Pick", xpRequired: 10000 },
];

export function getLevelForXp(totalXp: number): Level {
  for (let i = LEVELS.length - 1; i >= 0; i--) {
    if (totalXp >= LEVELS[i].xpRequired) return LEVELS[i];
  }
  return LEVELS[0];
}

export function getNextLevel(totalXp: number): Level | null {
  const current = getLevelForXp(totalXp);
  const nextIndex = LEVELS.findIndex((l) => l.level === current.level) + 1;
  return nextIndex < LEVELS.length ? LEVELS[nextIndex] : null;
}

export function getLevelProgress(totalXp: number): number {
  const current = getLevelForXp(totalXp);
  const next = getNextLevel(totalXp);
  if (!next) return 100;
  const range = next.xpRequired - current.xpRequired;
  const progress = totalXp - current.xpRequired;
  return Math.min(Math.round((progress / range) * 100), 100);
}

export function didLevelUp(previousXp: number, newXp: number): boolean {
  return getLevelForXp(previousXp).level < getLevelForXp(newXp).level;
}
